import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// ACTIONS
import { listLections, listFilters } from "redux/actions/lectionActions";

// COMPONENTS
import Meta from "components/Meta/Meta";
import SectionTitle from "components/Sections/SectionTitle";
import Spinner from "components/Loaders/Spinner";
import Tags from "components/Buttons/Tags";
import CardEvent from "components/cards/CardEvent";

function LectionPage() {
  const dispatch = useDispatch();

  const [state, setState] = useState({
    currentFilter: "",
    currentFilterTitle: "Все",
  });
  const { currentFilter, currentFilterTitle } = state;

  const lectionsList = useSelector((state) => state.lections.lectionsList);

  const { loading, error, lections } = lectionsList;
  const lectionFilters = useSelector((state) => state.lections.lectionFilters);
  const { loading: filtersLoading, filters } = lectionFilters;

  useEffect(() => {
    dispatch(listFilters());
  }, [dispatch]);

  useEffect(() => {
    dispatch(listLections(currentFilter, "", false));
  }, [dispatch, currentFilter]);

  // HANDLE FILTER BY CATEGORY
  const handleFiltering = (filter, topic) => {
    setState({
      currentFilter: filter,
      currentFilterTitle: topic,
    });
  };

  return (
    <>
      <Meta
        title={"Лекторий Другие Измерения — книги, кофе и другие измерения"}
        description="Лекторий Другие Измерения — это современная интерактивная площадка для проведения различных мероприятий"
      />
      <main className="margined-navbar">
        <SectionTitle title={"Лекторий"} isBackButton={true} />
        {filtersLoading || !filters ? (
          <Spinner />
        ) : (
          <Tags
            data={!filtersLoading ? filters.data : []}
            action={handleFiltering}
            currentFilter={currentFilter === "" ? "all" : currentFilter}
            element={"lection-filter"}
          />
        )}
        <section className="section--lectorium-page__all-lections">
          <div className="container">
            <div className="content-bar">
              <span className="current__filter--lections">
                {currentFilterTitle}
              </span>
              <div className="button-group"></div>
            </div>
            <div className="cards-wrapper">
              {loading || !lections ? (
                <Spinner />
              ) : error ? (
                <h1>{error}</h1>
              ) : (
                lections.map((lection) => (
                  <CardEvent key={lection._id} event={lection} />
                ))
              )}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default LectionPage;
